import React from 'react';
import { Route } from 'react-router-dom';

export default ({ render: C, props: childProps, ...rest }) => (
  <Route {...rest} render={(rProps) => <C {...rProps} {...childProps} />} />
);
